<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{ navigationTitle }}</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <!-- 这里边是一个表单 -->
    <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
      <el-card class="box-card">
        <el-form-item label="病例名称" prop="title">
          <el-col :span="13">
            <el-input type="textarea" v-model="reference.title" placeholder="请输入病例名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="病历简介" prop="desc">
          <el-input type="textarea" rows="2" v-model="reference.desc" placeholder="请输入病历简介"></el-input>
        </el-form-item>
        <el-form-item label="病例详情" prop="detail">
          <!-- style="height: 400px" -->
          <!-- 这里是一个富文本 -->
          <div class="quillEditor">
            <el-upload class="avatar-uploader" :action="action" name="file" :show-file-list="false"
              :on-success="uploadSuccess" :before-upload="beforeUpload" :data="{ file: 'file', model: '' }"></el-upload>
            <quill-editor class="ql-editor" v-model="reference.detail" :options="editorOption" ref="myQuillEditor"
              @change="onEditorChange($event)">
            </quill-editor>
          </div>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <el-form-item label="封面图" prop="image" class="inage-form-item">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span class="inage-form-item-warn">请上传比例2：1图片</span>
        </el-form-item>
        <el-form-item label="就诊科室" prop="cate_id">
          <el-col :span="6">
            <el-select v-model="reference.cate_id" placeholder="请选择" filterable>
              <el-option v-for="item in sectionsList" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="作者">
          <el-col :span="13">
            <el-input v-model="reference.author" placeholder="请输入病例作者"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>
 
<script>
import { Quill } from 'vue-quill-editor'
window.Quill = Quill
import { ImageDrop } from 'quill-image-drop-module';
Quill.register('modules/imageDrop', ImageDrop);
import ImageResize from 'quill-image-resize-module'  //添加
Quill.register('modules/imageResize', ImageResize)
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 如果上传文件参考https://blog.csdn.net/weixin_40682842/article/details/110630443 
// const toolbarOptions = [
//   ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
//   ['blockquote', 'code-block'], // 引用  代码块
//   [{ header: 1 }, { header: 2 }], // 1、2 级标题 
//   [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
//   [{ script: 'sub' }, { script: 'super' }], // 上标/下标
//   [{ indent: '-1' }, { indent: '+1' }], // 缩进
//   [{ direction: 'rtl' }], // 文本方向
//   [{ size: ['12', '14', '16', '18', '20', '22', '24', '28', '32', '36'] }], // 字体大小
//   [{ font: [false, 'heiti', 'songti', 'kaiti', 'lishu', 'arial', 'monospace'] }] // 字体 false默认微软雅黑，其他可删减
//   [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
//   [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色  
//   // [{ font: ['songti'] }], // 字体种类
//   [{ align: [] }], // 对齐方式  
//   ['clean'], // 清除文本格式
//   ['image',] // 链接、图片、视频     //上传图片、上传视频 'video' 
// ]  
// 自定义字体大小
let Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '16px', '18px', '20px', '30px', '32px']
Quill.register(Size, true)
// 自定义字体类型
var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

//处理文本对齐
// let Align = Quill.import("attributors/style/align");
// let aligns = [false, "right", "center", "justify"];
// Align.whitelist = aligns;
// Quill.register(Align, true); 
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ 'direction': 'rtl' }],                         // 文本方向
  [{ size: ['10px', '12px', false, '16px', '18px', '20px', '30px', '32px'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif'] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["image",] // 链接、图片、视频
];
export default {
  name: 'editorProject',
  data() {
    return {
      navigationTitle: '录入病例',
      sectionsList: [],
      model: [],
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      TextImg: '',
      reference: {
        title: '', //名称
        desc: '', //简介
        detail: '', //详情
        image: '', //图片 
        cate_id: '', //科室id
        author: '', //作者  
        id: '', //添加为空 修改传病历id
        project_id: '', //指南共识id 
      },
      rules: {
        title: [
          { required: true, message: '请输入病例标题', trigger: 'blur' },
        ],
        desc: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
        detail: [
          { required: true, message: '请输入病例详情', trigger: 'change' },
        ],
        cate_id: [
          { required: true, message: '请选择科室', trigger: 'change' },
        ],
      },
      editorOption: {
        modules: {
          imageDrop: true, //图片拖拽
          imageResize: {
            //放大缩小
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize',] //'Toolbar'居中 
          },
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) { //编辑器-上传图片
                if (value) {
                  // 调用antd图片上传upload
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
              upload: value => { //编辑器-上传文件
                if (value) {
                  document.querySelector('.uploadFile input').click()
                }
              }
            }
          },
        },
        theme: 'snow',
      }
    }
  },
  mounted() {
    this.getSections()
    this.reference.id = this.$route.query.id
    if (this.reference.id != "") this.compileEntry(this.$route.query.id)
  },
  methods: {
    beforeUpload(file) { },
    //上传富文本图片
    uploadSuccess(res) {
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.data.url)
        // 调整光标到最后 
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败！')
      }
    },
    //编辑进入 
    async compileEntry(id) {
      this.navigationTitle = '编辑病例'
      const { data: data } = await this.$http.post("bl/detail", {
        id
      })
      this.reference = data.data
      this.reference.project_id = ''
      delete this.reference.cate_id_text
      this.imageUrl = data.data.image
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单  
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getsubmitApi()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交表单接口
    async getsubmitApi() {
      const { data: data } = await this.$http.post("bl/add", this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.backProject()
    },
    //返回
    backProject() {
      this.$router.back()
    },
    //富文本事件
    onEditorChange(e) {
      // console.log('富文本的事件', e)
    },
    //头像图片上传成功  
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.image = res.data.url
    },
    //获取科室
    async getSections() {
      const { data: data } = await this.$http.post("cate/list", {
        type: 1
      })
      this.sectionsList = data.data
    },
  },
  beforeDestroy() {
    this.quillObj = null
    delete this.quillObj
  },
}
</script> 

<style>
.editor {
  line-height: normal !important;
  height: 300px;
}

.SizeTiShi {
  font-size: 12px;
  color: #999999;
  text-align: right;
  /* margin-right: 20px; */
  margin-top: 60px;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px" !important;
  font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px" !important;
  font-size: 10px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px" !important;
  font-size: 12px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px" !important;
  font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px" !important;
  font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px" !important;
  font-size: 20px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30px" !important;
  font-size: 30px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px" !important;
  font-size: 32px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本" !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1" !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2" !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3" !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4" !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5" !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
  content: "宋体" !important;
  font-family: "SimSun";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
  content: "黑体" !important;
  font-family: "SimHei";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Microsoft-YaHei"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Microsoft-YaHei"]::before {
  content: "微软雅黑" !important;
  font-family: "Microsoft YaHei";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
  content: "楷体" !important;
  font-family: "KaiTi";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
  content: "仿宋" !important;
  font-family: "FangSong";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
  content: "Arial" !important;
  font-family: "Arial";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Times-New-Roman"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Times-New-Roman"]::before {
  content: "Times New Roman" !important;
  font-family: "Times New Roman";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
  content: "sans-serif" !important;
  font-family: "sans-serif";
}

.ql-font-SimSun {
  font-family: "SimSun";
}

.ql-font-SimHei {
  font-family: "SimHei";
}

.ql-font-Microsoft-YaHei {
  font-family: "Microsoft YaHei";
}

.ql-font-KaiTi {
  font-family: "KaiTi";
}

.ql-font-FangSong {
  font-family: "FangSong";
}

.ql-font-Arial {
  font-family: "Arial";
}

.ql-font-Times-New-Roman {
  font-family: "Times New Roman";
}

.ql-font-sans-serif {
  font-family: "sans-serif";
}
</style> 
 

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  // padding: 0 26px 24px 26px;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    margin-bottom: 40px;
  }

  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 132px;
    height: 66px;
    display: block;
  }

  // 上传文件
  .el-select {
    display: block;
  }

  .uploads {
    display: flex;

    .upload-demo {
      display: flex;

      // align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }

      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;

        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }

    .ticks {
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  /deep/ .ql-container {
    // height: 192px;
    min-height: 192px;
    // p {
    //   min-height: 192px;
    // }
  }

  /deep/.ql-editor {
    padding: 0;
  }

  .el-icon-plus {
    width: 132px !important;
    height: 66px !important;
  }

  .inage-form-item {
    position: relative;

    .inage-form-item-warn {
      position: absolute;
      bottom: 5px;
      left: 145px;
      color: #cc0808;
      font-size: 12px;
    }
  }

  // .quill-editor-up {
  //   // width: 18px;
  //   // height: 18px;
  //   // position: absolute;
  //   // top: 31px;
  //   // right: 530px;
  //   // z-index: 999;
  //   // background-color: pink;
  // }
}
</style>